'use client'

import { useCallback, useState, useEffect } from 'react'

const STORAGE_KEY = 'hs-recently-viewed'
const MAX_ITEMS = 8

export interface HsRecentItem {
  hsCode: string
  description: string
  timestamp: number
}

export function useHsRecentlyViewed() {
  const [items, setItems] = useState<HsRecentItem[]>([])
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        setItems(JSON.parse(stored))
      }
    } catch (error) {
      console.error('Failed to load hs recently viewed:', error)
    } finally {
      setIsLoaded(true)
    }
  }, [])

  const addItem = useCallback((item: Omit<HsRecentItem, 'timestamp'>) => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      const existing: HsRecentItem[] = stored ? JSON.parse(stored) : []

      // Remove duplicate if exists
      const filtered = existing.filter((i) => i.hsCode !== item.hsCode)

      // Add new item at the beginning
      const updated = [
        { ...item, timestamp: Date.now() },
        ...filtered,
      ].slice(0, MAX_ITEMS)

      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
      setItems(updated)
    } catch (error) {
      console.error('Failed to save hs recently viewed:', error)
    }
  }, [])

  return { items, addItem, isLoaded }
}
